import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import useDateFnsLocale from 'hooks/useDateFnsLocale'
import { MONTH_NAME_YEAR, YEAR_MONTH } from 'modules/constants'
import { getMonthList } from 'modules/utils/helpers'
import { FC } from 'react'
import { ASelectFilter } from '../Analytics'

type Props = {
  value: any
  updateFilterState: (filterObj: Record<string, any>) => void
  allowClear?: boolean
  placeholder?: string
}

export const MonthFilter: FC<Props> = ({ value, updateFilterState, allowClear = true, placeholder }) => {
  const { t } = useTranslation()
  const locale = useDateFnsLocale()
  const dateOptions = getMonthList().map((date) => ({
    value: format(date, YEAR_MONTH),
    label: capitalizeFirstLetter(format(date, MONTH_NAME_YEAR, { locale })),
  }))

  return (
    <ASelectFilter
      id="monthFilter"
      options={dateOptions}
      value={value}
      onChange={(month) => updateFilterState({ month })}
      placeholder={placeholder || t('common:month')}
      allowClear={allowClear}
      showSearch={false}
    />
  )
}
